<script>
    import PrintButton from './toolbar/PrintButton.svelte'

    export let printEnabled = true;
</script>

<style>
    .report-toolbar {
        min-height: 3em;
        color: white;
        background-color: #5B6161;
        box-shadow: 0 2px 2px rgba(0,0,0, 0.3);
        position: relative;
        padding-right: 6em;
        display: flex;
        align-items: center;
    }

    .spacing {
        flex: 1;
    }

    @media print {
        .report-toolbar {
            display: none;
        }
    }

    .report-toolbar :global(button[disabled] > i) {
        background: transparent;
        opacity: 0.8;
    }
</style>

<div class="report-toolbar">
    <div class="spacing"></div>
    <slot name="extraButtons"></slot>
    <slot name="printButton">
        {#if printEnabled}
            <PrintButton></PrintButton>
        {/if}
    </slot>
    <slot name="closeButton"></slot>
</div>

